import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AppNav from "../components/appNav";
import Footer from "../components/footer";
import PageSection from "../components/PageSection";
import ArrowIcon from "../components/ArrowIcon";

type StatusKind = "live" | "available";

const AI_PRODUCTS: { key: "islasVivas" | "productivity" | "documents"; path: string; status: StatusKind }[] = [
  { key: "islasVivas",   path: "/ai-data/islas-vivas",  status: "live" },
  { key: "productivity", path: "/ai-data/productivity", status: "available" },
  { key: "documents",    path: "/ai-data/documents",    status: "available" },
];

const AiDataPage = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-paper text-ink">
      <header className="sticky top-0 z-50 bg-paper/95 backdrop-blur-[2px] border-b border-ink-14">
        <AppNav />
      </header>

      <main>
        {/* 01 / AI & Data hero */}
        <PageSection marker={t("kode.aiData.sectionLabel")} noTop topPadClass="!pt-12">
          <h1 className="section-h-lg">
            {t("kode.aiData.h1Line1")}
            <br />
            {t("kode.aiData.h1Line2")}
          </h1>
          <p className="text-body-lg text-ink-70 mt-6" style={{ maxWidth: "60ch" }}>
            {t("kode.aiData.lead")}
          </p>

          <div className="props">
            {[1, 2, 3, 4].map((n) => (
              <div className="row" key={n}>
                <div className="k">{t(`kode.aiData.prop${n}K`)}</div>
                <div className="v">{t(`kode.aiData.prop${n}V`)}</div>
              </div>
            ))}
          </div>
        </PageSection>

        {/* 02 / Products */}
        <PageSection marker={`02 / ${t("kode.nav.aiData")}`}>
          <h2 className="section-h">{t("kode.aiData.productsH2")}</h2>
          <p className="section-sub">{t("kode.aiData.productsSub")}</p>

          <div className="products-stack">
            {AI_PRODUCTS.map(({ key, path, status }) => {
              const isLive = status === "live";
              return (
                <Link to={path} className="product" key={key}>
                  <div className="top">
                    <span className="name">{t(`kode.products.${key}.name`)}</span>
                    <span className={`status${isLive ? " live" : ""}`}>
                      {t(`kode.common.${status}`)}
                    </span>
                  </div>
                  <p className="desc">{t(`kode.products.${key}.summary`)}</p>
                  <span className="for">
                    {t("kode.common.for")} <b>{t(`kode.products.${key}.audience`)}</b>
                  </span>
                </Link>
              );
            })}
          </div>
        </PageSection>

        {/* 03 / Talk */}
        <PageSection marker={`03 / ${t("kode.common.talk")}`}>
          <h3 className="section-h">{t("kode.aiData.talkH3")}</h3>
          <p className="section-sub">{t("kode.common.talkSub")}</p>
          <div className="flex flex-wrap gap-3 mt-5">
            <Link to="/contact" className="btn btn-primary">
              {t("kode.common.bookCall")}
              <ArrowIcon className="h-4 w-4" />
            </Link>
            <a href="mailto:hugo@kode.zone" className="btn btn-secondary">
              hugo@kode.zone
            </a>
          </div>
        </PageSection>

        <Footer />
      </main>
    </div>
  );
};

export default AiDataPage;
